/* default style for component */
export const style = {
  parentChatBox: {
    margin: {
      xs: "28px 8px 0 8px",
      sm: "35px 25px 0 25px",
    },
  },

  questionParent: {
    display: "flex",
    justifyContent: "right",
    marginBottom: {
      xs: "15px",
      sm: "20px",
      md: "23px",
    },
    gap: "12px",
  },

  questionBox: {
    border: "1px solid #020067",
    minHeight: "auto",
    borderRadius: "20px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    opacity: 1,
    backdropFilter: "blur(30px)",
    webkitBackdropFilter: "blur(30px)",
    paddingRight: "3rem",
  },

  answerParent: {
    display: "flex",
    marginBottom: {
      xs: "-15px",
      sm: "-8px",
      md: "23px",
    },
    gap: "12px",
  },

  answerBox: {
    border: "1px solid #020067",
    minHeight: "auto",
    borderRadius: "20px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    opacity: 1,
    backdropFilter: "blur(30px)",
    webkitBackdropFilter: "blur(30px)",
    padding: "10px",
  },

  userIcon: {
    width: { xs: "40px", sm: "40px", md: "3vw" },
    background:
      "transparent url('img/Group 475.png') 0% 0% no-repeat padding-box",
    opacity: 1,
  },

  userIcon2: {
    width: { xs: "40px", sm: "40px", md: "3vw" },
    background:
      "transparent url('img/Group 475.png') 0% 0% no-repeat padding-box",
    opacity: 1,
  },

  chatText: {
    fontFamily: "Quicksand",
    fontWeight: "bold",
    color: "#393939",
    pl: {
      xs: 1,
      sm: 1,
      md: 2,
    },
    fontSize: {
      xs: "14px",
      sm: "15px",
      md: "17px",
    },
    margin: "revert",
  },

  konvergeLogo: {
    fontSize: {
      xs: "35px",
      sm: "35px",
      md: "45px",
    },
    alignSelf: "center",
    color: "#FD7E00",
    mr: {
      xs: 1,
      sm: 1,
      md: 2,
    },
  },
};
